// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { Environment } from '@models';

export const environment: Environment = {
  name: 'default',
  production: false,

  remoteApi: 'https://localhost:7266/api',
  sentryEnvironment: 'dev',
};
